import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSuperAdminStats, getRecentActivity } from "../service/dashboardService";
import type { RecentActivity, SuperAdminStats } from "../types";

interface SuperAdminDashboardState {
  stats: SuperAdminStats | null;
  recent: RecentActivity | null;
  loading: boolean;
  error: string | null;
}

const initialState: SuperAdminDashboardState = {
  stats: null,
  recent: null,
  loading: false,
  error: null,
};

export const fetchSuperAdminStats = createAsyncThunk(
  "superAdminDashboard/fetchStats",
  async (_, { rejectWithValue }) => {
    try {
      return await getSuperAdminStats();
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.error ?? "Failed to fetch stats");
    }
  }
);

export const fetchRecentActivity = createAsyncThunk(
  "superAdminDashboard/fetchRecent",
  async (_, { rejectWithValue }) => {
    try {
      return await getRecentActivity();
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.error ?? "Failed to fetch recent activity");
    }
  }
);

const superAdminDashboardSlice = createSlice({
  name: "superAdminDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuperAdminStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSuperAdminStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload;
      })
      .addCase(fetchRecentActivity.fulfilled, (state, action) => {
        state.recent = action.payload;
      })
      .addCase(fetchSuperAdminStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default superAdminDashboardSlice.reducer;